import Config from "../config/constants";
import axios, { AxiosResponse } from 'axios';

export const apiGetNotices = async (page: number, limit: number, msgType:number, accessToken:string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/notice/list`;
    
    try {
        const response = await axios.get(url, {
            params: {
                page,
                limit, 
                msgType
            },headers: { access_token: accessToken }
        });
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};

export const apiGetNoticesTitle = async (page: number, limit: number, msgType:number, accessToken:string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/notice/list_title`;
    
    try {
        const response = await axios.get(url, {
            params: {
                page,
                limit, 
                msgType
            },headers: { access_token: accessToken }
        });
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};

export const apiGetNotice = async (noticeid: number, accessToken:string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/notice/read/${noticeid}`;
    
    try {
        const response = await axios.get(url, {headers: { access_token: accessToken }});
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};

export const apiRegisterNotice = async (params: any, accessToken:string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/notice/register`;
    
    try {
        const response = await axios.post(url, params, {headers: { access_token: accessToken }});
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};

export const apiPatchNotice = async (params: any, id: number, accessToken:string) => {
    const url = `${Config.API_HOST}/api/admin/notice/update/${id}`;
    console.log(url);
    try {
      const response = await axios.patch(url, params, {headers: { access_token: accessToken }}); // 수정된 부분
      return response.data; 
    } catch (error) {
      console.error('Error updating user:', error);
      throw error; 
    }
};

export const apiFileUpload = async (params: any, accessToken: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/notice/fileupload`;
    
    try {
        const response = await axios.post(url, params, {headers: { access_token: accessToken }});
        return response.data; 
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; 
    }
};

export const apiDeleteNotice = async (id: number, accessToken:string) => {
    const url = `${Config.API_HOST}/api/admin/notice/${id}`;
    console.log(url);
    try {
      const response = await axios.delete(url, {headers: { access_token: accessToken }}); // 수정된 부분
      return response.data; 
    } catch (error) {
      console.error('Error updating user:', error);
      throw error; 
    }
};